import moment from 'moment-timezone';

/**
 * Clone as moment without re-wrapping. Plain `moment(zonedMoment)` drops moment-timezone's
 * zone and breaks startOf/endOf day for salon-local picks; clone preserves `_z`.
 */
const asMoment = (v) => (moment.isMoment(v) ? v.clone() : moment(v));

/** @param {import('moment').Moment | string | number | Date} v */
export const toIsoStartOfSchedulerDay = (v) => asMoment(v).startOf('day').toISOString();

/** @param {import('moment').Moment | string | number | Date} v */
export const toIsoEndOfSchedulerDay = (v) => asMoment(v).endOf('day').toISOString();
